"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormat = void 0;
const numberRound_1 = require("./numberRound");
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 8
 */
function numberFormat(value, precision = 8) {
    if (value === null) {
        return '';
    }
    if (value % 1 === 0) {
        return value.toString();
    }
    return (0, numberRound_1.numberRound)(value, precision).toString().replace('.', ',');
}
exports.numberFormat = numberFormat;
//# sourceMappingURL=numberFormat.js.map